import { useState } from "react";
import { BackButton } from "../../../../../components/features/BackButton";
import { BeautyProfilerMainFragranceResults } from "./main-fragrance/BeautyProfilerMainFragranceResults";
import { BeautyProfilerDetailedResults } from "./detailed/BeautyProfilerDetailedResults";
import { BeautyProfilerResults } from "../../../types/BeautyProfilerResults";

type BeautyProfilerResultsProps = {
  onBack: () => void;
  getResults: () => BeautyProfilerResults | null;
};

export const BeautyProfilerResultsPage = ({
  onBack,
  getResults,
}: BeautyProfilerResultsProps) => {
  const [activeTab, setActiveTab] = useState<"fragrance" | "detailed">(
    "fragrance"
  );

  const results = getResults();
  return (
    <div className="h-full overflow-scroll">
      {activeTab === "fragrance" ? (
        <>
          <div className="absolute bottom-8 left-8 z-10 text-white">
            <BackButton onClick={onBack} />
          </div>
          <BeautyProfilerMainFragranceResults
            setActiveTab={setActiveTab}
            topAllure={results?.allure ?? null}
            topFetiche={results?.mainFeticheFragrance ?? null}
          />
        </>
      ) : (
        <>
          <div className="absolute bottom-8 left-8 z-10 text-white">
            <BackButton onClick={() => setActiveTab("fragrance")} />
          </div>
          <BeautyProfilerDetailedResults
            topFetiche={results?.mainFeticheFragrance ?? null}
            topSecondaryFragrances={{
              secondFetiche: results?.secondaryFeticheFragrance ?? null,
              topLoubiworld: results?.topLoubiworldFragrance ?? null,
            }}
            topOtherProduct={{
              topGlamliner: results?.topGlamliner ?? null,
              topOtherProducts: results?.topOtherProducts ?? [],
            }}
          />
        </>
      )}
    </div>
  );
};
